import React, { useEffect, useState } from "react";
import api from "@/lib/api";
import { PageHeader, EmptyState } from "@/components/Primitives";

export default function StudentNotifications() {
  const [list, setList] = useState([]);

  const load = () => api.get("/notifications").then(r => setList(r.data));
  useEffect(() => { load(); }, []);

  const markRead = async (id) => { await api.post(`/notifications/${id}/read`); load(); };

  return (
    <div>
      <PageHeader eyebrow="Inbox" title="Notifications" subtitle="Exam alerts, assignment deadlines and result announcements." />
      {list.length === 0 ? <EmptyState /> : (
        <div className="space-y-2">
          {list.map(n => (
            <button key={n.id} onClick={() => !n.read && markRead(n.id)} data-testid={`notif-${n.id}`}
              className={`w-full text-left card-academic p-5 ${n.read ? "opacity-70" : "border-l-2 border-terracotta"}`}>
              <div className="flex items-center gap-3 mb-1">
                {!n.read && <span className="w-2 h-2 bg-terracotta rounded-full" />}
                <div className="overline">{n.created_at?.slice(0, 16)}</div>
              </div>
              <h4 className="font-serif text-lg text-forest">{n.title}</h4>
              <p className="text-sm text-mossy">{n.message}</p>
            </button>
          ))}
        </div>
      )}
    </div>
  );
}
